<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ row.created_at }}
      </p>
    </div>

    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ row.user_id }}
      </p>
    </div>

    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ row.type }}
      </p>
    </div>

    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ getAmount(row) }}
      </p>
    </div>

    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ getWallet(row) }}
      </p>
    </div>

    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ row.status }}
      </p>
    </div>
    <div :class="b('cell')">
      <p :class="b('row-label')">
        {{ getMessage(row) }}
      </p>
    </div>
  </div>
</template>
